var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "detail-padding out_box" }, [
    _c(
      "div",
      { staticClass: "common-card is-border card_l" },
      [_c("LeftList", { ref: "LeftList" })],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "common-card is-border card_r" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "all" },
        [
          _vm._m(1),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "balance" },
            [
              _vm._v("\n        Balance : "),
              _c("big-number", { attrs: { number: _vm.TATbalance } }),
              _vm._v(" REP\n      "),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "tat_box" }, [
            _c(
              "div",
              { staticClass: "tat_input" },
              [
                _c("img", {
                  staticStyle: {
                    width: "0.36rem",
                    height: "0.36rem",
                    "margin-right": "0.08rem",
                  },
                  attrs: { src: require("@/assets/image/exchange/tat1.png") },
                }),
                _vm._v(" "),
                _c("b", [_vm._v("REP")]),
                _vm._v(" "),
                _c("el-input", {
                  staticClass: "exchange-input",
                  attrs: { placeholder: "0.00" },
                  model: {
                    value: _vm.tatVal,
                    callback: function ($$v) {
                      _vm.tatVal = $$v
                    },
                    expression: "tatVal",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "des" }, [
              _vm._v("Please enter the amount you want to stake"),
            ]),
          ]),
          _vm._v(" "),
          _vm._m(2),
          _vm._v(" "),
          _c(
            "el-button",
            { staticClass: "btn", on: { click: _vm.handleSubmit } },
            [_vm._v("Submit")]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("img", {
        staticStyle: {
          width: "0.3rem",
          height: "0.3rem",
          "margin-right": "0.08rem",
        },
        attrs: { src: require("@/assets/image/exchange/icon@2x.png") },
      }),
      _vm._v(" "),
      _c("span", [_vm._v("Stake REP")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "des" }, [
      _vm._v("\n        Become a "),
      _c("span", { staticClass: "lv-color" }, [_vm._v("Super Validator")]),
      _vm._v(" to get more\n        rewards.\n      "),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text_box" }, [
      _c("p", [_vm._v("Note:")]),
      _vm._v(" "),
      _c("p", [
        _vm._v("1.At least 1 REP staked, and your staked REP will be burned;"),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n          2.Each round is 5 minutes, and your staked REP is only valid\n              within these 5 minutes;\n        "
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n          3.If you want to participate in the next round, please stake again;\n        "
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n          4.The more staked REP, the greater the chance of being an\n              ActiveValidator.\n        "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }